import { Download } from '@icon-park/react'
import { useState } from 'react'
import { ChannelRowStatus } from '@shared/models'
import { useBaseAPI } from '@/modules/api/baseApi.hook'
import { Button } from '@/components'

interface ExportReportButtonProps {
  file: File
  companyID: string
  companyName?: string
  rows: ChannelRowStatus[]
}

export function ExportReportButton({ file, companyID, companyName, rows }: ExportReportButtonProps) {
  const { instance } = useBaseAPI()
  const [isExporting, setIsExporting] = useState(false)

  async function handleExport() {
    setIsExporting(true)
    try {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('rows', JSON.stringify(rows))
      const response = await instance.post(`channels/${companyID}/import/report`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        responseType: 'blob',
      })
      const url = URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.download = `resultado-importacao-${companyName}.xlsx`
      link.click()
      URL.revokeObjectURL(url)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button.Root $variant="primary" $loading={isExporting} onClick={handleExport}>
      <Button.Icon value={Download} size={16} color="white" />
      <Button.Text value="Exportar Relatório" />
    </Button.Root>
  )
}
